import React, { useEffect, useState } from 'react';
import { cloneDeep } from 'lodash';
import { useDispatch } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import classNames from 'classnames';
import { Helmet } from 'react-helmet';

import * as api from '../../../utils/api';
import { Table } from '../../common/Table/Table';
import PageHeader from '../../common/PageHeader/PageHeader';
import { Days, NotificationFrequency } from '../../../utils/constants';

import { Button } from '@praktio/common-ui';
import { useQuery } from '../../../utils/functions';
import { forceMaintenance } from '../../../utils/api';

import './Online.scss';

const UserHeaders = [
  { Header: 'Email', accessor: 'email', isId: true, className: 'Users-email' },
  { Header: 'First Name', accessor: 'firstName', className: 'Users-first' },
  { Header: 'Last Name', accessor: 'lastName', className: 'Users-last' },
  {
    Header: 'Notification',
    accessor: 'notification',
  },
];

const Online = () => {
  const dispatch = useDispatch();
  const query = useQuery();
  const force = query.get('force') === '1';
  const [onlineData, setOnlineData] = useState<IUser[]>([]);

  const getData = async () => {
    try {
      const response = await api.getOnlineData();
      setOnlineData(response.data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getData();
  }, [dispatch]);

  let users: IUser[] = [];
  if (onlineData) {
    users = onlineData.map((u) => {
      const user = cloneDeep(u);
      const { reportNotification } = user;
      let notification: string | number | undefined = reportNotification?.frequency || 'Not Set';
      if (reportNotification) {
        const { frequency, day, date } = reportNotification;
        switch (frequency) {
          case NotificationFrequency.Weekly:
            notification = Object.keys(Days).find((k) => Days[k] === day);
            break;
          case NotificationFrequency.Monthly:
            notification = date;
            break;
          default:
            break;
        }
      }

      return { ...user, notification };
    });
  }

  return (
    <Container fluid className="Online">
      <Helmet>
        <title>Online - Praktio</title>
      </Helmet>
      <Row className="h-100">
        <Col className={classNames('p-0 h-100', 'd-flex flex-column col-xs-12')}>
          <PageHeader pageName="Users Online">
            <Button className="secondary" onClick={() => getData()}>
              REFRESH
            </Button>
            {force && (
              <div className="maintenance-row">
                <Button className="secondary" onClick={() => forceMaintenance()}>
                  FORCE
                </Button>
              </div>
            )}
          </PageHeader>
          <div className="Online-content">
            <Table columns={UserHeaders} data={users} />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Online;
